import * as React from 'react';
import type { I18nConfig } from '../schema';

export interface ContentEditI18nContextValue {
    /** Active content `config.i18n` while editing */
    i18n?: I18nConfig;
    /** Host or content default language (e.g. `vi`) */
    language?: string;
}

const ContentEditI18nContext = React.createContext<ContentEditI18nContextValue | null>(null);

export interface ContentEditI18nProviderProps {
    i18n?: I18nConfig;
    language?: string;
    children: React.ReactNode;
}

/** Supplies parent content locale to nested element editors (e.g. `PageEdit`). */
export function ContentEditI18nProvider({
    i18n,
    language,
    children,
}: ContentEditI18nProviderProps): React.ReactElement {
    const value = React.useMemo(
        () => ({ i18n, language }),
        [i18n, language]
    );
    return (
        <ContentEditI18nContext.Provider value={value}>
            {children}
        </ContentEditI18nContext.Provider>
    );
}

export function useContentEditI18n(): ContentEditI18nContextValue | null {
    return React.useContext(ContentEditI18nContext);
}
